var map = {
	"./en/common.json": [
		77065,
		[
			7065
		]
	],
	"./en/kiddie.json": [
		40042,
		[
			42
		]
	],
	"./en/middle.json": [
		75517,
		[
			5517
		]
	],
	"./en/teacher.json": [
		20614,
		[
			614
		]
	],
	"./es-MX/common.json": [
		48670,
		[
			8670
		]
	],
	"./es-MX/kiddie.json": [
		12765,
		[
			2765
		]
	],
	"./es-MX/middle.json": [
		91874,
		[
			1874
		]
	],
	"./es-MX/teacher.json": [
		33063,
		[
			3063
		]
	],
	"./pt-BR/common.json": [
		80865,
		[
			865
		]
	],
	"./pt-BR/kiddie.json": [
		1826,
		[
			1826
		]
	],
	"./pt-BR/middle.json": [
		98549,
		[
			8549
		]
	],
	"./pt-BR/teacher.json": [
		37230,
		[
			7230
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 55677;
module.exports = webpackAsyncContext;